import { useEffect, useState } from 'react';
import useIsLoggedIn from 'tradera/hooks/use-is-loggedin';
import useIsDesktop from 'tradera/hooks/use-is-desktop';
import styles from './start-page-footer-banner.module.scss';
import { useAppSelector } from 'tradera/state/hooks';
import type { BannerLinkIcon } from 'tradera/state/views/start-page/types';
import { classNames } from 'tradera/utils/class-names';

export const StartPageFooterBanner = () => {
    const isLoggedIn = useIsLoggedIn();
    const isDesktop = useIsDesktop();
    const [activeIndex, setActiveIndex] = useState(0);

    const { bannerLinks } = useAppSelector(
        (state) => state.views.startPage.config.header,
    );

    const shouldRender = bannerLinks && bannerLinks.length > 0 && !isLoggedIn;

    useEffect(() => {
        if (!isDesktop && shouldRender) {
            const interval = setInterval(() => {
                setActiveIndex((activeIndex + 1) % bannerLinks.length);
            }, 4000);
            return () => clearInterval(interval);
        }
    }, [isDesktop, activeIndex, bannerLinks?.length, shouldRender]);

    const content = (text: string, icon?: BannerLinkIcon) => (
        <>
            {icon && icon.baseUrl && (
                <img
                    src={icon.baseUrl}
                    alt={text}
                    className={classNames(
                        'icon icon-md mr-2',
                        styles.bannerIconDark,
                    )}
                />
            )}
            <span className="text-styled size-paris">{text}</span>
        </>
    );

    return shouldRender ? (
        <div
            className={classNames(
                styles.banner,
                'w-100 px-2 px-xl-4 d-flex justify-content-center bg-white border-top',
            )}>
            <div className="site-width d-flex w-75 align-items-center justify-content-around position-relative">
                {bannerLinks.map(({ text, url, icon }, index) => (
                    <div
                        className={classNames(
                            styles.bannerItem,
                            'd-flex justify-content-center align-items-center text-dark mx-lg-4',
                            activeIndex === index && styles.bannerItemActive,
                        )}
                        key={text}>
                        {url ? (
                            <a
                                href={url}
                                className="d-flex align-items-center"
                                target="_blank"
                                rel="noreferrer">
                                {content(text, icon)}
                            </a>
                        ) : (
                            content(text, icon)
                        )}
                    </div>
                ))}
            </div>
        </div>
    ) : null;
};
